import ProductPriceMcom from './ProductPrice.mcom.vue';
import ProductPriceBcom from './ProductPrice.bcom.vue';

const brand = import.meta.env.VITE_ENTRY_POINT; // Do not inline, it breaks prod build for some reason
const ProductPrice = brand === 'mcom' ? ProductPriceMcom : ProductPriceBcom;

export default ProductPrice;
